<template>
  <div class="row mb-2">
    <div class="col">
      <z-message v-model="notice" :timeout="3000" class="alert alert-warning" />
    </div>
  </div>
  <div class="row">
    <div class="col-1">
      <ul class="nav nav-pills nav-fill custom-nav">
        <li v-for="tab in tabs" :key="tab" class="nav-item">
          <a class="nav-link" :class="{ active: currentTab === tab }" href="#" @click="setConfigTab(tab)">
            {{ tab }}
          </a>
        </li>
      </ul>
    </div>
    <div class="col">
      <div v-if="currentTab === 'Insurance'" class="row">
        <div class="row">
          <div class="col-6">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">Insurance</span>
              </div>
              <select v-model="currentInsurance" class="form-select">
                <option v-for="company in insurance" :key="company.insurance" :value="company.insurance">{{ company.insuranceName }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-6 ps-4">
            <input v-model="isIncludeCalibrationRecommendations" type="checkbox" class="custom-checkbox ml-4" />
            <span class="ms-2 mt-1">Include Calibration Recommendations on Reports</span>
          </div>
        </div>
      </div>
      <div v-if="currentTab === 'Programs'" class="row">
        <div class="col-6">
          <div class="row">
            <div class="col">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">Programs</span>
                </div>
                <input v-model="workingProgramName" type="text" :disabled="!addingProgram" class="form-control" @keyup="programChanged()" />
                <button v-if="!addingProgram" class="btn btn-primary" @click="newProgram()">New</button>
                <button v-if="addingProgram && changedProgram" class="btn btn-danger" @click="addProgram()">
                  <i class="fas fa-save"></i>
                </button>
                <button v-if="addingProgram" class="btn btn-primary custom-cancel" @click="clearProgram()">
                  <i class="fas fa-xmark"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col">
              <ul class="custom-list">
                <li v-for="program in programs" :key="program.id">
                  <div class="row">
                    <div class="col">
                      <span>{{ program.name }}</span>
                    </div>
                    <div class="col-1 text-right">
                      <div @click="removeProgram(program)">
                        <i class="fas fa-trash custom-trash"></i>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div v-if="currentTab === 'License'" class="row">
        <div class="col custom-editor">
          <editor ref="zEditor" v-model="license" content-type="html" @message="showMessage" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { locationStore } from '@/stores/location'
import { lookupStore } from '@/stores/lookup'
import globals from '@/plugins/globals'
import ZMessage from '@/components/utilities/elements/Message.vue'
import Editor from '@/components/utilities/elements/Editor.vue'
export default {
  name: 'LocationConfiguration',
  components: {
    ZMessage,
    Editor
  },
  data() {
    return {
      notice: '',
      tabs: ['Insurance', 'License'],
      currentTab: 'Insurance',
      selectedProgram: null,
      addingProgram: false,
      changedProgram: false,
      workingProgramName: ''
    }
  },
  emits: ['saved', 'changed'],
  computed: {
    ...mapState(locationStore, ['location', 'preferences']),
    ...mapState(lookupStore, ['insurance']),
    programs() {
      let _data = []
      if (this.preferences) {
        let found = this.preferences.find((element) => element.name === 'Programs')
        if (found) {
          if (found.value) {
            if (globals.isJson(found.value)) {
              _data = JSON.parse(found.value)
            }
          }
        }
      }
      return _data
    },
    currentInsurance: {
      get() {
        let _data = null
        if (this.preferences) {
          let found = this.preferences.find((element) => element.name === 'Insurance')
          if (found) {
            _data = found.value
          }
        }
        return _data
      },
      set(value) {
        let data = {
          firm: this.location.firm,
          type: 'General',
          name: 'Insurance',
          value: value.toString()
        }
        this.updatePreference(data)
        this.$emit('changed')
      }
    },
    license: {
      get() {
        let _data = null
        if (this.preferences) {
          let found = this.preferences.find((element) => element.name === 'License')
          if (found) {
            _data = found.value
          }
        }
        return _data
      },
      set(value) {
        let data = {
          firm: this.location.firm,
          type: 'General',
          name: 'License',
          value: value
        }
        this.updatePreference(data)
        this.$emit('changed')
      }
    },
    isIncludeCalibrationRecommendations: {
      get() {
        let _data = false
        if (this.preferences) {
          let found = this.preferences.find((element) => element.name === 'IncludeCalibrationRecommendations')
          if (found) {
            _data = found.value === 'true'
          }
        }
        return _data
      },
      set(value) {
        let data = {
          firm: this.location.firm,
          type: 'General',
          name: 'IncludeCalibrationRecommendations',
          value: value.toString()
        }
        this.updatePreference(data)
        this.$emit('changed')
      }
    }
  },
  methods: {
    ...mapActions(locationStore, ['updatePreference', 'savePreferences']),
    init() {
      this.currentTab = 'Programs'
    },
    setConfigTab(tab) {
      this.currentTab = tab
      // if (tab === 'License') {
      //   this.setBody()
      // }
    },
    // changed() {
    //   let data = {
    //     firm: this.location.firm,
    //     type: 'General',
    //     name: 'License',
    //     value: this.editorBody()
    //   }
    //   this.updatePreference(data)
    //   this.$emit('changed')
    // },
    clearProgram() {
      this.selectedProgram = null
      this.addingProgram = false
      this.changedProgram = false
      this.workingProgramName = ''
    },
    newProgram() {
      this.addingProgram = true
      this.changedProgram = false
      this.workingProgramName = ''
      this.selectedProgram = {
        id: null,
        name: '',
        isNew: true
      }
    },
    programChanged() {
      this.changedProgram = true
    },
    addProgram() {
      if (this.selectedProgram) {
        let programs = JSON.parse(JSON.stringify(this.programs))
        if (this.workingProgramName.trim() !== '') {
          let found = programs.find((element) => element.name === this.workingProgramName.trim())
          if (!found) {
            if (this.workingProgramName.trim() !== '') {
              let id = 1
              if (programs.length > 0) {
                id = programs[programs.length - 1].id + 1
              }
              this.selectedProgram.id = id
              this.selectedProgram.name = this.workingProgramName.trim()
              programs.push(this.selectedProgram)
            }
            let data = {
              firm: this.location.firm,
              type: 'General',
              name: 'Programs',
              value: JSON.stringify(programs)
            }
            this.updatePreference(data)
          }
          this.clearProgram()
          this.$emit('changed')
        }
      }
    },
    removeProgram(program) {
      if (program) {
        let programs = this.programs.filter((element) => element.id !== program.id)
        let data = {
          firm: this.location.firm,
          type: 'General',
          name: 'Programs',
          value: JSON.stringify(programs)
        }
        this.updatePreference(data)
        this.clearProgram()
        this.$emit('changed')
      }
    },
    setBody() {
      this.$refs.zEditor.setHTML(null)
      if (this.license) {
        this.$refs.zEditor.setHTML(this.license)
      }
    },
    editorBody() {
      let body = ''
      if (this.$refs.zEditor) {
        body = this.$refs.zEditor.getHTML()
        if (body === '' || body === '<p><br></p>') {
          body = ''
        }
      }
      return body
    },
    async save() {
      await this.savePreferences()
      this.$emit('saved')
      return {
        valid: true,
        msg: null
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-nav {
  text-align: center;
}
.custom-editor {
  height: 270px;
}
.custom-cancel {
  border-left: 1px solid #fff;
}
.custom-list {
  list-style: none;
  li {
    padding-top: 5px;
    padding-bottom: 5px;
  }
}
.custom-trash {
  color: rgb(173, 0, 0);
  :hover {
    cursor: pointer;
  }
}
</style>
